import React from 'react'
import "../assets/js/main";
import "../assets/css/style.css"

const Skills = () => {

    // const { bgcolor, completed } = props;

    // const containerStyles = {
    //   height: 20,
    //   width: '100%',
    //   backgroundColor: "#e0e0de",
    //   borderRadius: 50,
    //   margin: 50
    // }
  return (
    <section id="skills" class="skills section-bg">
    <div class="container">
        <div class="section-title">
            <h2>Skills</h2>
            <p>In a constantly changing environment, having life skills is an essential part of being able to meet the challenges of everyday life. Skills in which <span style={{fontWeight:"bold",color: "blue"}}>I'm</span> expert and offers are:</p>
        </div>
        <div class="">
            {/* <div class="col-lg-6" data-aos="fade-up"> */}
            <div class="good" data-aos="fade-up">
            <div className='new'>
            <div className='progres'>
                    <spn className="title">Node JS</spn>
                    <div className='skill-bar'>
                        <span className='skill-per nodejs'>
                            <span className='tool'>97%</span>
                        </span>
                    </div>
                </div>
                <div className='progres'>
                    <spn className="title">HTML/CSS</spn>
                    <div className='skill-bar'>
                        <span className='skill-per html'>
                            <span className='tool'>95%</span>
                        </span>
                    </div>
                </div>
                <div className='progres'>
                    <spn className="title">JavaScript</spn>
                    <div className='skill-bar'>
                        <span className='skill-per javascript'>
                            <span className='tool'>92%</span>
                        </span>
                    </div>
                </div>
                <div className='progres'>
                    <spn className="title">MySQL</spn>
                    <div className='skill-bar'>
                        <span className='skill-per javascript'>
                            <span className='tool'>90%</span>
                        </span>
                    </div>
                </div>
                
                
               
               
</div>
<div className='new'>

                <div className='progres'>
                    <spn className="title">Express JS</spn>
                    <div className='skill-bar'>
                        <span className='skill-per expressjs'>
                            <span className='tool'>97%</span>
                        </span>
                    </div>
                    </div>
                <div className='progres'>
                    <spn className="title">MongoDB</spn>
                    <div className='skill-bar'>
                        <span className='skill-per javascript'>
                            <span className='tool'>90%</span>
                        </span>
                    </div>
                </div>
                <div className='progres'>
                    <spn className="title">Prisma(ORM)</spn>
                    <div className='skill-bar'>
                    <div className='skill-per javascript'>
                        <span className='skill-per css'><span className='tool'>90%</span>
                        </span>
                    </div>
                    </div>
                </div>
                <div className='progres'>
                    <spn className="title">Sequelize(ORM)</spn>
                    <div className='skill-bar'>
                        <span className='skill-per javascript'>
                            <span className='tool'>90%</span>
                        </span>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</section>
  )
}

export default Skills